import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { ReopenSurveyLinksRPC } from "./reopenSurveyLinksRPC";

export class ReopenSurveyLinksRPCClientImpl extends ReopenSurveyLinksRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: ReopenSurveyLinksRPC.Request): Promise<LeoRPCResult<ReopenSurveyLinksRPC.Response, ReopenSurveyLinksRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/ReopenSurveyLinks",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      ReopenSurveyLinksRPC.ResponseDTO,
      ReopenSurveyLinksRPC.Errors.ErrorsDTO,
      ReopenSurveyLinksRPC.Response,
      ReopenSurveyLinksRPC.Errors.Errors
    >(
      response,
      "respondent/ReopenSurveyLinks",
      ReopenSurveyLinksRPC.Response.fromDTO,
      ReopenSurveyLinksRPC.Errors.fromDTO
    );
  }
}
